module.exports = __webpack_public_path__ + "img/cityPartner.d9b43a82.jpg";